import { render, staticRenderFns } from "./ChooseNumbers.vue?vue&type=template&id=8cacd584&scoped=true"
import script from "./ChooseNumbers.vue?vue&type=script&lang=js"
export * from "./ChooseNumbers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cacd584",
  null
  
)

export default component.exports